import GTM from '../../Components/GTM/GTM';
export default {
	init() {

		var container = document.querySelector('.singleProduct');

		if( container ) {

			function singleProductSetShippingMethod( value ) {

				var formData = ''+
					'action=' 		+ 'swiSetShippingMethod' + '&' +
					'shipping=' 	+ value
				;

				var ajaxUrl = document.querySelector('footer').getAttribute('data-endpoint');
				var response;

				var xhr = new XMLHttpRequest();
				xhr.open( 'POST', ajaxUrl, true );
				xhr.setRequestHeader( 'Content-type', 'application/x-www-form-urlencoded' );
				xhr.send( formData );

			}

			function singleProductShippingRadio( container ) {

				var labels = container.querySelectorAll('.singleProduct__information .information__form .shipping__list label');
				var labelsValue = (labels.length / 2 );
				

				labels.forEach( function(label, index) {

					label.addEventListener('click', function(){
						
						labels.forEach( function(label2,index2) {

							label2.classList.remove('active');
							label2.querySelector('input').checked = false;


						});

						label.classList.add('active');
						label.querySelector('input').checked = true ;

						if( index <= 2 ) {

							labels[ index+labelsValue ].classList.add('active');
							labels[ index+labelsValue ].querySelector('input').checked = true;

						} else {

							labels[ index-labelsValue ].classList.add('active');
							labels[ index-labelsValue ].querySelector('input').checked = true;

						}

						singleProductSetShippingMethod( label.querySelector('input').value );

					});

				});

			}

			function singleProductRightSticky( container ) {

				var stickyElement = container.querySelector('.singleProduct__row .row__right .singleProduct__information');

				var main = document.querySelector('main');
				var mainPadding = 0;

				function checkIfCanBySticky() {

					mainPadding = parseFloat( getComputedStyle( main ).getPropertyValue('padding-top').replace('px','') );
					
					if( ( window.innerHeight - mainPadding - 24 ) > stickyElement.offsetHeight ) {

						stickyElement.classList.add('sticky');

					} else {

						stickyElement.classList.remove('sticky');

					}

				}

				checkIfCanBySticky();

				window.addEventListener('resize', function() { checkIfCanBySticky(); } );

			}

			function productOutOfStockGalleryMaskDisable( container ) {

				if( container.querySelector('.gallery__mask') ) {

					var mask = container.querySelector('.gallery__mask');
					var maskButton = mask.querySelector('.mask__close');

					maskButton.addEventListener('click', function() {

						mask.classList.remove('active');
						setTimeout(
							function() {
								mask.remove();
							},
							500
						)

					});

				}

			}
			
			singleProductShippingRadio( container );
			singleProductRightSticky( container );
			productOutOfStockGalleryMaskDisable( container );

			// -- GTM register add to cart -- //
				var gtmOBJ = new GTM();
				document.querySelectorAll('.addProdToCart').forEach( function( button, index ) {
					button.addEventListener('click', function() {
						
						gtmOBJ.addToCart( 
							button.closest('.information__row').querySelector('input[name="add-to-cart"]').value,
							button.closest('.information__row').querySelector('input[name="quantity"]').value
						);

					});
				});
			// -- END -- //
			
		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
